import { Controller } from "@hotwired/stimulus";

// Keeps the fixed header transparent while at the top of the page (the hero
// plate runs behind it, as designed) and gives it a solid background once
// the visitor scrolls.
export default class extends Controller {
  connect() {
    this.onScroll = () => {
      this.element.classList.toggle("header-scrolled", window.scrollY > 8);
    };
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }
}
